define("shared/components/shared/ui/list-uploaded-items", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "shared/utils/uuid"], function (_exports, _component, _templateFactory, _component2, _uuid) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@glimmer/component",0,"shared/utils/uuid"eaimeta@70e063a35619d71f

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class={{this.className}}>
    {{#each @allUploadedFiles as |file|}}
      <div class="u--p__tb">
        <a href={{file.url}} rel="noopener noreferrer" target="_blank">
          {{file.filename}}
        </a>
  
        <Shared::Ui::Button
          @onClick={{action @removeFile file}}
          @variant="none"
          aria-hidden="true"
          class="o--alert__dismiss"
        >
          {{svg-jar "close" class="o--icon"}}
        </Shared::Ui::Button>
  
        <br />
      </div>
    {{/each}}
  </div>
  */
  {
    "id": "cMdtYaGW",
    "block": "[[[10,0],[15,0,[30,0,[\"className\"]]],[12],[1,\"\\n\"],[42,[28,[37,1],[[28,[37,1],[[30,1]],null]],null],null,[[[1,\"    \"],[10,0],[14,0,\"u--p__tb\"],[12],[1,\"\\n      \"],[10,3],[15,6,[30,2,[\"url\"]]],[14,\"rel\",\"noopener noreferrer\"],[14,\"target\",\"_blank\"],[12],[1,\"\\n        \"],[1,[30,2,[\"filename\"]]],[1,\"\\n      \"],[13],[1,\"\\n\\n      \"],[8,[39,2],[[24,\"aria-hidden\",\"true\"],[24,0,\"o--alert__dismiss\"]],[[\"@onClick\",\"@variant\"],[[28,[37,3],[[30,0],[30,3],[30,2]],null],\"none\"]],[[\"default\"],[[[[1,\"\\n        \"],[1,[28,[35,4],[\"close\"],[[\"class\"],[\"o--icon\"]]]],[1,\"\\n      \"]],[]]]]],[1,\"\\n\\n      \"],[10,\"br\"],[12],[13],[1,\"\\n    \"],[13],[1,\"\\n\"]],[2]],null],[13]],[\"@allUploadedFiles\",\"file\",\"@removeFile\"],false,[\"each\",\"-track-array\",\"shared/ui/button\",\"action\",\"svg-jar\"]]",
    "moduleName": "shared/components/shared/ui/list-uploaded-items.hbs",
    "isStrictMode": false
  });

  class ListUploadedItemsComponent extends _component2.default {
    constructor() {
      super(...arguments);

      _defineProperty(this, "className", `list-uploaded-items-${(0, _uuid.default)()}`);
    }

  }

  _exports.default = ListUploadedItemsComponent;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ListUploadedItemsComponent);
});